import { Injectable } from '@angular/core';
import { DashboardProfileContextService, DashboardUserContextService } from '@rma/dashboard/authentication/public/user';
import { CurrentSubscriptionService } from '@rma/dashboard/billing/subscription-plans/public/api-subscription-features';
import { FeatureFlagService, TempFeatureFlags } from '@rma/dashboard/generic/util/feature-flags';
import { isIndividual } from '@rma/generic/domain/helpers';
import { cache } from 'decorator-cache-getter';
import { combineLatest, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TeamCalloutService {
  constructor(
    private readonly currentSubscriptionService: CurrentSubscriptionService,
    private readonly featuresService: FeatureFlagService,
    private readonly profileContextService: DashboardProfileContextService,
    private readonly userContextService: DashboardUserContextService,
  ) {}

  @cache
  public get showTeamsCallout$() {
    return combineLatest([
      this.featuresService.getFeature$(TempFeatureFlags.ShowTeamsBanner, false),
      this.currentSubscriptionService.currentSubscription$,
      this.profileContextService.profileIdentifier$,
      //TODO: TOM !!! This is one of thoseplace you want to update to use the profileAccessService
      this.userContextService.currentUser$.pipe(map((x) => x?.agencies?.filter((y) => y.agentGroupingType === 'Team') ?? [])),
    ]).pipe(
      map(
        ([feature, currentSubscription, profileIds, existingTeamAdmin]) =>
          feature &&
          !currentSubscription.isProvided &&
          isIndividual(profileIds) &&
          !currentSubscription.onTrial &&
          !currentSubscription.isFree &&
          existingTeamAdmin.length === 0,
      ),
    );
  }
}
